var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgDonationPlain = function SvgDonationPlain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.96 14v6.664c0 1.621 0 2.431-.326 3.046a2.8 2.8 0 01-1.165 1.165c-.614.325-1.425.325-3.046.325H9.575c-1.62 0-2.431 0-3.046-.325a2.8 2.8 0 01-1.164-1.165c-.326-.614-.326-1.425-.326-3.046V14m.56 0h16.8s0 0 0 0a2.8 2.8 0 002.8-2.8s0 0 0 0v0s0 0 0 0a2.8 2.8 0 00-2.8-2.8s0 0 0 0h-16.8s0 0 0 0a2.8 2.8 0 00-2.8 2.8s0 0 0 0v0s0 0 0 0a2.8 2.8 0 002.8 2.8s0 0 0 0zm8.399 11.2V8.4",
    stroke: "#fff",
    strokeOpacity: 0.8,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.4H8.96a2.8 2.8 0 110-5.6C12.88 2.8 14 8.4 14 8.4z",
    stroke: "#fff",
    strokeOpacity: 0.8,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.998 8.4h5.04a2.8 2.8 0 100-5.6c-3.92 0-5.04 5.6-5.04 5.6z",
    stroke: "#fff",
    strokeOpacity: 0.8,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDonationPlain;